import React from 'react';

import { ReactComponent as UnlockedIcon } from '../../../../src/styles/icon/unlock.svg';
import { ReactComponent as LockedIcon } from '../../../../src/styles/icon/lock.svg';

import authorize from './Authorize.module.scss';

const AuthorizeOperationBtn = ({ isAuthorized, onClick }) => {
  const handleAuthClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className={isAuthorized ? 'authorization__btn locked' : 'authorization__btn unlocked'}
      aria-label={isAuthorized ? 'authorization button locked' : 'authorization button unlocked'}
      onClick={handleAuthClick}
    >
      {!isAuthorized ? (
        <UnlockedIcon className={authorize.authorize__icon} />
      ) : (
        <LockedIcon className={authorize.authorize__icon} />
      )}
    </button>
  );
};

export default AuthorizeOperationBtn;
